import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TargetCandidate } from '../../Models/web-recorded-command-model';

export class ElementDetailsModel {
  constructor(
    public candidates: TargetCandidate[]
  ) {}
}

@Component({
  selector: 'ze-element-details-modal',
  templateUrl: './element-details-modal.component.html',
  styleUrls: ['./element-details-modal.component.scss']
})
export class ElementDetailsModalComponent {
  candidates: TargetCandidate[];

  constructor(
    public dialogRef: MatDialogRef<ElementDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ElementDetailsModel
  ) {
    // Natural captured order, unsorted — matches the reference extension's
    // own Element Details table exactly (it doesn't reorder textContent to
    // the top either).
    this.candidates = data.candidates;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
